import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

var displayableVehicleProperties = ['licensePlate', 'make', 'model', 'year'];

var fn = function fn($scope, $translate, $filter, ModalService, TranslateService, StateUtils, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.vehicleIncidentsVm = $scope.claimVm.lobs.commercialAuto.vehicleIncidents;
    };

    function openInvalidIncidents() {
        $scope.vehicleIncidentsVm.children.forEach(function (incident) {
            incident.value.open = !incident._aspects.subtreeValid;
        });
    }

    ctrl.addVehicleIncident = function (vehiclesForm) {
        vehiclesForm.submitted = true;
        if (vehiclesForm.valid) {
            var newVi = $scope.claimVm.lobs.commercialAuto.value.createVehicleIncident();
            newVi.open = true;
            newVi.vehicle = $scope.claimVm.lobs.commercialAuto.value.createVehicle();
            vehiclesForm.submitted = false;
            vehiclesForm.setPristine();
        } else {
            openInvalidIncidents();
        }
    };

    ctrl.removeVehicleIncidentConfirmation = function (vehicleIncident) {
        var message = $translate('fnol.ca.controllers.CACollisionVehicleCtrl.Are you sure you want to delete this third party vehicle?');
        var modalPromise = ModalService.showWarning('fnol.ca.controllers.CACollisionVehicleCtrl.Delete Third Party Vehicle?', message, undefined, $filter('translate')('fnol.ca.controllers.CACollisionVehicleCtrl.Yes'), undefined, $filter('translate')('fnol.ca.controllers.CACollisionVehicleCtrl.No')).result;
        modalPromise.then(function () {
            if ($scope.claimVm.lobs.commercialAuto.vehicleIncidents.length > 1) {
                $scope.claimVm.lobs.commercialAuto.value.removeVehicleIncident(vehicleIncident.value);
            }
        });
    };

    ctrl.isNewVehicle = function (vehicleIncident) {
        return vehicleIncident.vehicle.value && !vehicleIncident.vehicle.policyVehicle.value;
    };

    ctrl.getVehicleTabHeading = function (vehicleIncident) {
        var vehicle = vehicleIncident.vehicle.value;
        var tabHeading = displayableVehicleProperties.filter(function (prop) {
            return vehicle[prop];
        }).map(function (prop) {
            return vehicle[prop];
        }).join(' ');

        return tabHeading.length === 0 ? TranslateService.instant('fnol.ca.controllers.CACollisionVehicleCtrl.New Vehicle') : tabHeading;
    };

    ctrl.next = function (flowNextFn, form) {
        form.submitted = true;
        if (form.invalid) {
            openInvalidIncidents();
        }
        changeEmptyToUndefined();
        flowNextFn($scope.claimVm);
    };

    function changeEmptyToUndefined() {
        _.each($scope.claimVm.lobs.commercialAuto.vehicleIncidents.value, function (vehicleIncident) {
            if (vehicleIncident.vehicle.vIN === '') {
                vehicleIncident.vehicle.vIN = undefined;
            }
        });
    }

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$translate', '$filter', 'ModalService', 'TranslateService', 'StateUtils', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/controllers/CACollisionVehiclesCtrl.js
// module id = 1497
// module chunks = 0